import { Ajax } from '../classes/ajax';

export function LoadFood(id) {
    return function(dispatch) {
        dispatch({
            type: 'FOOD/LOAD',
        });

        return new Ajax('GET', 'menu/' + id, null).then((result) => {
            dispatch({
                type: 'FOOD/LOAD_FINISHED',
                payload: {
                    food: result.data.item,
                },
            });
        });
    };
}

export function ConfirmFood(food) {
    return function(dispatch) {
        dispatch({
            type: 'FOOD/CONFIRM',
            payload: {
                food: food,
            },
        });
    };
}
